import * as React from "react";

/**
 * Returns true when the viewport width is at most `breakpoint` pixels.
 * SSR/hydration use false (wide viewport) so the tree matches useMediaQuery("(min-width: 768px)")'s initial false.
 */
export function useIsScreenWidth(breakpoint: number) {
  const query = `(max-width: ${breakpoint}px)`;

  const subscribe = React.useCallback(
    (onStoreChange: () => void) => {
      const mq = window.matchMedia(query);
      mq.addEventListener("change", onStoreChange);
      return () => mq.removeEventListener("change", onStoreChange);
    },
    [query],
  );

  const getSnapshot = React.useCallback(
    () => window.matchMedia(query).matches,
    [query],
  );

  const getServerSnapshot = React.useCallback(() => false, []);

  return React.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
